export const schoolFormEstablishmentTypes = [
  { value: 'elementarySchool', label: 'Elémentaires' },
  { value: 'college', label: 'Collèges' },
  { value: 'specializedEstablishment', label: 'Établissements spécialisés' },
  { value: 'LGT', label: 'LGT' },
  { value: 'LP', label: 'LP' },
  { value: 'LPO', label: 'LPO' },
  { value: 'agricole', label: 'Agricoles' },
];

export const otherGroupsFormEstablishmentTypes = [
  { value: 'CFA', label: 'CFA' },
  { value: 'MFR', label: 'MFR' },
  {
    value: 'mission-locale',
    label: 'Missions locales',
  },
  {
    value: 'entreprises',
    label: 'Entreprises',
  },
  {
    value: 'association',
    label: 'Associations',
  },
  {
    value: 'autre',
    label: 'Autres écoles',
  },
];

export const typeQuries = {
  specializedEstablishment: `(libelle_nature="COLLEGE" OR libelle_nature="COLLEGE CLIMATIQUE" OR libelle_nature="COLLEGE SPECIALISE" OR libelle_nature="ECOLE SECONDAIRE SPECIALISEE (2 D CYCLE)" 
      OR libelle_nature="ECOLES COMPOSEES UNIQT DE STS ET OU CPGE" 
      OR libelle_nature="ETAB REGIONAL/LYCEE ENSEIGNEMENT ADAPTE" 
      OR libelle_nature="ETABLISSEMENT DE REINSERTION SCOLAIRE" 
      OR libelle_nature="ETABLISSEMENT MEDICO-EXPERIMENTAL" 
      OR libelle_nature="ETABLISSEMENT POUR DEFICIENTS AUDITIFS" 
      OR libelle_nature="ETABLISSEMENT POUR DEFICIENTS VISUELS" 
      OR libelle_nature="ETABLISSEMENT POUR INFIRMES MOTEURS" 
      OR libelle_nature="ETABLISSEMENT POUR POLY-HANDICAPES" 
      OR libelle_nature="ETABLISSEMENT POUR SOURDS-AVEUGLES")
      OR type_etablissement="EREA"`,
  college:
    '(libelle_nature="COLLEGE" OR libelle_nature="COLLEGE CLIMATIQUE" OR libelle_nature="COLLEGE SPECIALISE")',
  LGT: `(
        libelle_nature="LYCEE CLIMATIQUE" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT GENERAL" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT TECHNOLOGIQUE"
        OR libelle_nature="LYCEE ENSEIGNT GENERAL ET TECHNOLOGIQUE"
        OR libelle_nature="LYCEE EXPERIMENTAL"
        OR libelle_nature="SECTION ENSEIGT GENERAL ET TECHNOLOGIQUE")
        `,
  LP: '(libelle_nature="LYCEE PROFESSIONNEL")',
  LPO: '(libelle_nature="LYCEE POLYVALENT" OR libelle_nature="SECTION D ENSEIGNEMENT PROFESSIONNEL")',

  // Elementary School
  elementarySchool: '(ecole_elementaire="1")',

  // Agriculture School
  agricole:
    '((ministere_tutelle="AGRICULTURE" AND type_etablissement="Lycée") OR (ministere_tutelle="AGRICULTURE" AND type_etablissement="Autre"))',
  autre: '(ministere_tutelle="AGRICULTURE" AND type_etablissement="Autre")',
};

export const classLevels = [
  { value: 'cp', label: 'CP' },
  { value: 'ce1', label: 'CE1' },
  { value: 'ce2', label: 'CE2' },
  { value: 'cm1', label: 'CM1' },
  { value: 'cm2', label: 'CM2' },
  { value: '6eme', label: '6ème' },
  { value: '5eme', label: '5ème' },
  { value: '4eme', label: '4ème' },
  { value: '3eme', label: '3ème' },
  { value: 'seconde', label: 'Seconde' },
  { value: 'premiere', label: 'Première' },
  { value: 'terminale', label: 'Terminale' },
  { value: 'cap-1ere-annee', label: 'CAP 1ère année' },
  { value: 'cap-2eme-annee', label: 'CAP 2ème année' },
  { value: 'bts-1ere-annee', label: 'BTS 1ère année' },
  { value: 'bts-2eme-annee', label: 'BTS 2ème année' },
  { value: 'other', label: 'Autres' },
];

export const visitDays = [
  { value: 'thu', label: 'Je 16.10' },
  { value: 'fri', label: 'Ve 17.10' },
  { value: 'sat', label: 'Sa 18.10' },
];

export const arrivalTimes = {
  thu: [
    { value: '09h00 - 09h30', label: '09h00 - 09h30' },
    { value: '09h30 - 10h00', label: '09h30 - 10h00' },
    { value: '10h00 - 10h30', label: '10h00 - 10h30' },
    { value: '10h30 - 11h00', label: '10h30 - 11h00' },
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
  ],
  fri: [
    { value: '09h00 - 09h30', label: '09h00 - 09h30' },
    { value: '09h30 - 10h00', label: '09h30 - 10h00' },
    { value: '10h00 - 10h30', label: '10h00 - 10h30' },
    { value: '10h30 - 11h00', label: '10h30 - 11h00' },
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
  ],
  sat: [
    { value: '09h00 - 09h30', label: '09h00 - 09h30' },
    { value: '09h30 - 10h00', label: '09h30 - 10h00' },
    { value: '10h00 - 10h30', label: '10h00 - 10h30' },
    { value: '10h30 - 11h00', label: '10h30 - 11h00' },
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
  ],
};

export const departureTimes = {
  thu: [
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
    { value: '15h00 - 15h30', label: '15h00 - 15h30' },
    { value: '15h30 - 16h00', label: '15h30 - 16h00' },
    { value: '16h00 - 16h30', label: '16h00 - 16h30' },
    { value: '16h30 - 17h00', label: '16h30 - 17h00' },
  ],
  fri: [
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
    { value: '15h00 - 15h30', label: '15h00 - 15h30' },
    { value: '15h30 - 16h00', label: '15h30 - 16h00' },
    { value: '16h00 - 16h30', label: '16h00 - 16h30' },
    { value: '16h30 - 17h00', label: '16h30 - 17h00' },
  ],
  sat: [
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
    { value: '15h00 - 15h30', label: '15h00 - 15h30' },
    { value: '15h30 - 16h00', label: '15h30 - 16h00' },
  ],
};

export const modesOfTransport = [
  { value: 'publicTransport', label: 'TER – RTM (Réseau métropolitain)' },
  { value: 'busOrCoachesPrivate', label: 'Bus / autocars (privés)', disabled: true },
  { value: 'carpooling', label: 'Covoiturage' },
  { value: 'other', label: 'Autres' },
];

export const tourTypes = [
  { value: 'introduction', label: 'Introduction à la visite' },
  { value: 'guided', label: 'Parcours accompagné' },
];

export const timeSlots = {
  introduction: [
    { value: '09h15 - 09h45', label: '09h15 - 09h45' },
    { value: '10h00 - 10h30', label: '10h00 - 10h30' },
    { value: '10h45 - 11h15', label: '10h45 - 11h15' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h15 - 12h45', label: '12h15 - 12h45' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h45 - 14h15', label: '13h45 - 14h15' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
  ],
  guided: [
    {
      value: '09h15 - 10h45',
      label: '09h15 - 10h45',
      professionSlots: [
        { guidedTourType: 'type1', professionId: 'd2' },
        { guidedTourType: 'type1', professionId: 'd3' },
        { guidedTourType: 'type1', professionId: 'd4' },
        { guidedTourType: 'type1', professionId: 'd5' },
        { guidedTourType: 'type1', professionId: 'd6' },
        { guidedTourType: 'type1', professionId: 'd7' },
        { guidedTourType: 'type1', professionId: 'd8' },
        { guidedTourType: 'type1', professionId: 'd9' },
        { guidedTourType: 'type1', professionId: 'd10' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't2' },
        { guidedTourType: 'type2', professionId: 't3' },
      ],
    },
    {
      value: '09h30 - 11h00',
      label: '09h30 - 11h00',
      professionSlots: [
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't5' },
        { guidedTourType: 'type2', professionId: 't6' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g2' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g4' },
        { guidedTourType: 'type3', professionId: 'g5' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g7' },
        { guidedTourType: 'type3', professionId: 'g8' },
      ],
    },
    {
      value: '11h15 - 12h45',
      label: '11h15 - 12h45',
      professionSlots: [
        { guidedTourType: 'type1', professionId: 'd2' },
        { guidedTourType: 'type1', professionId: 'd3' },
        { guidedTourType: 'type1', professionId: 'd4' },
        { guidedTourType: 'type1', professionId: 'd5' },
        { guidedTourType: 'type1', professionId: 'd6' },
        { guidedTourType: 'type1', professionId: 'd7' },
        { guidedTourType: 'type1', professionId: 'd8' },
        { guidedTourType: 'type1', professionId: 'd9' },
        { guidedTourType: 'type1', professionId: 'd10' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't2' },
        { guidedTourType: 'type2', professionId: 't3' },
      ],
    },
    {
      value: '11h30 - 13h00',
      label: '11h30 - 13h00',
      professionSlots: [
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't5' },
        { guidedTourType: 'type2', professionId: 't6' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g2' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g4' },
        { guidedTourType: 'type3', professionId: 'g5' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g7' },
        { guidedTourType: 'type3', professionId: 'g8' },
      ],
    },
    {
      value: '13h15 - 14h45',
      label: '13h15 - 14h45',
      professionSlots: [
        { guidedTourType: 'type1', professionId: 'd2' },
        { guidedTourType: 'type1', professionId: 'd3' },
        { guidedTourType: 'type1', professionId: 'd4' },
        { guidedTourType: 'type1', professionId: 'd5' },
        { guidedTourType: 'type1', professionId: 'd6' },
        { guidedTourType: 'type1', professionId: 'd7' },
        { guidedTourType: 'type1', professionId: 'd8' },
        { guidedTourType: 'type1', professionId: 'd9' },
        { guidedTourType: 'type1', professionId: 'd10' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't2' },
        { guidedTourType: 'type2', professionId: 't3' },
      ],
    },
    {
      value: '13h30 - 15h00',
      label: '13h30 - 15h00',
      professionSlots: [
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't5' },
        { guidedTourType: 'type2', professionId: 't6' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g2' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g4' },
        { guidedTourType: 'type3', professionId: 'g5' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g7' },
        { guidedTourType: 'type3', professionId: 'g8' },
      ],
    },
    {
      value: '15h15 - 16h45',
      label: '15h15 - 16h45',
      disabledDays: ['fri'],
      professionSlots: [
        { guidedTourType: 'type1', professionId: 'd2' },
        { guidedTourType: 'type1', professionId: 'd3' },
        { guidedTourType: 'type1', professionId: 'd4' },
        { guidedTourType: 'type1', professionId: 'd5' },
        { guidedTourType: 'type1', professionId: 'd6' },
        { guidedTourType: 'type1', professionId: 'd7' },
        { guidedTourType: 'type1', professionId: 'd8' },
        { guidedTourType: 'type1', professionId: 'd9' },
        { guidedTourType: 'type1', professionId: 'd10' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't1' },
        { guidedTourType: 'type2', professionId: 't2' },
        { guidedTourType: 'type2', professionId: 't3' },
      ],
    },
    {
      value: '15h30 - 17h00',
      label: '15h30 - 17h00',
      disabledDays: ['fri'],
      professionSlots: [
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't4' },
        { guidedTourType: 'type2', professionId: 't5' },
        { guidedTourType: 'type2', professionId: 't6' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g1' },
        { guidedTourType: 'type3', professionId: 'g2' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g3' },
        { guidedTourType: 'type3', professionId: 'g4' },
        { guidedTourType: 'type3', professionId: 'g5' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g6' },
        { guidedTourType: 'type3', professionId: 'g7' },
        { guidedTourType: 'type3', professionId: 'g8' },
      ],
    },
  ],
};

export const guidedTourTypes = [
  {
    value: 'type1',
    label: 'Parcours Découverte',
    color: '#DF89E5',
    color2: '#df89e533',
    professions: [
      { value: 'd2', label: 'D2 - Exploration des métiers variés' },
      { value: 'd3', label: 'D3 - Exploration des métiers variés' },
      { value: 'd4', label: 'D4 - Exploration des métiers variés' },
      { value: 'd5', label: 'D5 - Exploration des métiers variés' },
      { value: 'd6', label: 'D6 - Exploration des métiers variés' },
      { value: 'd7', label: 'D7 - Exploration des métiers variés' },
      { value: 'd8', label: 'D8 - Exploration des métiers variés' },
      { value: 'd9', label: 'D9 - Exploration des métiers variés' },
      { value: 'd10', label: 'D10 - Exploration des métiers variés' },
    ],
  },
  {
    value: 'type2',
    label: 'Parcours Thématiques',
    color: '#363B90',
    color2: '#363b9033',
    professions: [
      { value: 't1', label: 'T1 - Les métiers de la construction' },
      { value: 't2', label: "T2 - L'art de la table et du service" },
      { value: 't3', label: 'T3 - Mobilité et transport' },
      { value: 't4', label: "T4 - Métiers de l'industrie" },
      { value: 't5', label: 'T5 - Numérique et Communication' },
      { value: 't6', label: 'T6 - Les métiers créatifs' },
    ],
  },
  {
    value: 'type3',
    label: 'Parcours par Goûts et Aptitudes',
    color: '#4DB14D',
    color2: '#4db14d33',
    professions: [
      { value: 'g1', label: "G1 - J'aime réparer" },
      { value: 'g2', label: "G2 - J'aime créer" },
      { value: 'g3', label: "G3 - J'aime travailler en extérieur" },
      { value: 'g4', label: "G4 - J'aime les métiers et gestes traditionnels" },
      { value: 'g5', label: "G5 - J'aime le travail minutieux" },
      { value: 'g6', label: "G6 - J'aime le contact humain et prendre soin" },
      { value: 'g7', label: "G7 - J'aime programmer, automatiser" },
      { value: 'g8', label: "G8 - J'aime résoudre des problèmes et analyser des situations" },
    ],
  },
];

export const NUMBER_OF_TOUR_STUDENTS = {
  introduction: { MIN: 10, MAX: 35 },
  guided: { MIN: 15, MAX: 25 },
};

export const FINAL_BOOKING_TIME = new Date('2025-10-10T10:00:00Z'); // 10 Oct 12PM CET
// export const FINAL_BOOKING_TIME = new Date('2025-10-09T13:41:55.704Z'); // test
